import { SearchInput } from '../shared';
import { Priority, SortOrder, TicketSortType, TicketStatus } from '../enums';
import moment from 'moment';

export class GetTicketsInput extends SearchInput<TicketSortType> {
    public ticketStatus: Array<TicketStatus> | null;
    public priority: Priority | null;
    public customerId: number | null;
    public projectId: number | null;
    public allProjectId: number | null = null;
    public fromDate: moment.Moment | null;
    public toDate: moment.Moment | null;
    public tagIds: Array<number>;
    public assignedEmployeeId: number | null;
    public ticketType: Array<number> | null;

    constructor() {
        super(TicketSortType.CreationDateTime);
        this.sortOrder = SortOrder.Descending;
        this.fromDate = null;
        this.toDate = null;
        this.assignedEmployeeId = null;
        this.ticketStatus = null;
        this.priority = null;
        this.customerId = null;
        this.projectId = null;
        this.tagIds = new Array<number>();
        this.ticketType = null;
    }
}
